import { render, staticRenderFns } from "./BuildingBig.vue?vue&type=template&id=2277320d"
import script from "./BuildingBig.vue?vue&type=script&lang=js"
export * from "./BuildingBig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports